<template lang="pug">
  .add-to-calendar(:class="{'--open': isOpened}")
    .add-to-calendar__button(@click.prevent="toggle()")
      img(:src="require('~/assets/img/icons/calendar.svg')" alt="calendar")
      .add-to-calendar__button-text {{ $t('addToCalendar') }}
    .add-to-calendar__items
      .add-to-calendar__item(@click="onGoogleClick")
        .add-to-calendar__item-text Google
        img(:src="require('~/assets/img/icons/google.svg')" alt="google")
      .add-to-calendar__item(@click="onFileClick")
        .add-to-calendar__item-text {{ $t('download') }} .ics
        img(:src="require('~/assets/img/icons/download.svg')" alt="download")

</template>

<script>
import { createEvent } from 'ics'
import qs from 'qs'
import TournamentMixin from '~/mixins/Tournament'

export default {
  name: 'AddToCalendar',

  mixins: [TournamentMixin],

  props: {
    tournament: {
      type: Object,
      required: true
    }
  },

  data: () => {
    return {
      isOpened: false
    }
  },

  mounted () {
    document.addEventListener('click', this.onClickOutside)
  },

  beforeDestroy () {
    document.removeEventListener('click', this.onClickOutside)
  },

  methods: {
    onFileClick () {
      const formatDate = (date) => {
        return [
          date.getFullYear(),
          date.getMonth() + 1,
          date.getDate(),
          date.getHours(),
          date.getMinutes()
        ]
      }

      const event = {
        start: formatDate(this.startsAt),
        end: formatDate(this.endsAt),
        title: this.tournament.title,
        url: `${this.$config.WWW_HOST}/${this.game?.name}/tournaments/${this.tournament.id}`,
        description: `${this.$t('tournament')} ${this.game.extra_data.title} ${
          this.$config.WWW_HOST
        }/${this.game?.name}/tournaments/${this.tournament.id}`,
        busyStatus: 'BUSY'
      }

      this.download(createEvent(event).value, 'calendar.ics', 'text/calendar')
    },

    download (data, filename, type) {
      const file = new Blob([data], { type })
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(file, filename)
      } else {
        // Others
        const a = document.createElement('a')
        const url = URL.createObjectURL(file)
        a.href = url
        a.download = filename
        document.body.appendChild(a)
        a.click()
        setTimeout(function () {
          document.body.removeChild(a)
          window.URL.revokeObjectURL(url)
        }, 0)
      }
    },

    onGoogleClick () {
      const url = 'http://www.google.com/calendar/event?'

      const params = {
        action: 'TEMPLATE',
        text: this.tournament.title,
        dates: (
          this.startsAt.toISOString() +
          '/' +
          this.endsAt.toISOString()
        ).replace(/[:-]/g, ''),
        details: `${this.$t('tournament')} ${this.game.extra_data.title} ${
          this.$config.WWW_HOST
        }/${this.game?.name}/tournaments/${this.tournament.id}`
      }

      window.open(url + qs.stringify(params), '_blank')
    },

    toggle (value) {
      if (value !== undefined) {
        this.isOpened = value
      } else {
        this.isOpened = !this.isOpened
      }
    },

    onClickOutside ({ target }) {
      if (!this.$el.contains(target) && this.isOpened) {
        this.toggle(false)
      }
    }
  }
}
</script>

<style lang="scss">
.add-to-calendar {
  @include button;

  position: relative;
  cursor: pointer;
  border-radius: 8px;
  background: $blue-grey60;
  height: 48px;
  transition: background 0.2s $easing;

  &.--open {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  &__item {
    @include button;

    display: flex;
    color: #fff;
    justify-content: space-between;
    padding: 5px;
    margin: 4px 0;
    height: 28px;
    transition: 0.2s $easing;

    &:hover {
      opacity: 0.7;
    }
  }

  &__items {
    padding: 6px 19px 7px;
    position: absolute;
    top: 100%;
    width: 100%;
    background: $blue-grey60;
    border-radius: 0 0 8px 8px;
    height: 0;
    overflow: hidden;
    transition: 0.1s $easing;
    visibility: hidden;
    pointer-events: none;

    .--open & {
      height: 81px;
      pointer-events: auto;
      visibility: visible;
      transition: 0.2s $easing;
    }
  }

  &__button {
    height: 48px;
    min-width: 48px;
    transition: all 0.2s $easing, border-radius 0s;
    color: #fff;
    display: flex;
    align-items: center;
    padding: 0 24px;
    white-space: nowrap;
    border-radius: 8px;

    &-text {
      overflow: hidden;
    }

    .--open & {
      color: $primary60;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }

    img {
      margin-right: 10px;

      path {
        transition: 0.2s $easing;

        .--open & {
          fill: $primary60;
        }
      }
    }

    &:hover {
      background: $blue-grey50;

      .--open & {
        background: $blue-grey60;
      }
    }
  }

  @media (max-width: $breakpointHeaderMobile) {
    height: 40px;

    img {
      width: 20px;
      height: 20px;
    }

    &__items {
      padding: 0 16px 4px;

      .--open & {
        height: 74px;
      }
    }

    &__button {
      width: 40px;
      height: 40px;
      min-width: 40px;
      padding: 0 0 0 10px;

      .--open & {
        width: 236px;
        padding: 0 16px;
      }

      &-text {
        width: 0;

        .--open & {
          width: 166px;
        }
      }
    }
  }
}
</style>
